import { Model } from '@shared/model/model';
import { Dictionary } from '@shared/types';

export class BaseEntity extends Model {
  static isType(type: unknown): type is typeof BaseEntity {
    return !!(type as Dictionary).getFields;
  }
}
